<template>
  <div class="card">
    <div class="card-header" style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr; gap: 20px">
      <el-input @change="filterKra" clearable placeholder="Họ tên SĐT, Mã nhân sự" v-model="filters.keyword" />
      <el-select v-model="filters.department" clearable @change="filterKra" multiple filterable collapse-tags placeholder="Chọn phòng ban">
        <el-option
            v-for="item in departments"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
      <el-date-picker
          v-model="filters.month"
          format="MM" class="w-100"
          value-format="M"
          type="month" @change="filterKra"
          placeholder="Chọn tháng">
      </el-date-picker>
      <el-date-picker
          v-model="filters.year"
          format="yyyy" class="w-100"
          value-format="yyyy"
          type="year" @change="filterKra"
          placeholder="Chọn năm">
      </el-date-picker>
      <el-select v-model="status" clearable @change="filterKra" placeholder="Chọn trạng thái">
        <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="card-body">
      <TableKra  :data-kra="dataKra" :page="page" :filters="filters" @getListKra="getListKra"/>
      <div v-if="dataKra?.length > 0">
        <div class="edu-paginate mx-auto text-center mt-10 mb-5"
             style="display: flex; justify-content: center; align-items: center; height: 50px">
          <paginate
              v-model="page"
              :page-count="lastPage"
              :page-range="3"
              :margin-pages="1"
              :click-handler="changePage"
              :prev-text="'Trước'"
              :next-text="'Sau'"
              :container-class="'pagination b-pagination'"
              :pageLinkClass="'page-link'"
              :next-link-class="'next-link-item'"
              :prev-link-class="'prev-link-item'"
              :prev-class="'page-link'"
              :next-class="'page-link'"
              :page-class="'page-item'"
          >
          </paginate>
        </div>
        <div class="w-100" style="display: flex;justify-content: flex-end; margin-top: -50px">
          <div>
            Tổng số bản ghi: <span
              style="color: #0066FF; font-weight: 600; margin-left: 5px;">{{
              this.total ?? dataKra.length
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GET_LIST_WAITING_KRA } from "@/core/services/store/okrs/okr.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_DEPARTMENT } from "@/core/services/store/user/users.module";
import { statusOptions } from "@/common/define";
import TableKra from "@/view/pages/manage-kras/component/TableKras.vue";
import { KraModel } from "@/view/pages/manage-kras/model/KraModel";
import moment from "moment-timezone";

export default {
  name: 'ManageKraList',
  components: { TableKra },
  data() {
    return {
      loading: false,
      filters: {
        keyword: null,
        department: null,
        status: null,
        month: null,
        year: null,
      },
      statusOptions,
      departments: [],
      dataKra: [],
      page: 0,
      total: 0,
      lastPage: 0
    }
  },
  methods: {
    changePage(obj) {
      this.page = obj;
      this.getListKra()
    },
    getListKra() {
      this.loading = true
      const payload = {
        keyword: this.filters.keyword,
        department: this.filters.department,
        status: this.filters.status,
        month: this.filters.month ?? moment(new Date()).format("M"),
        year: this.filters.year ?? moment(new Date()).format("YYYY")
      }
      this.$store.dispatch(GET_LIST_WAITING_KRA, payload).then(res => {
        if (!res.error) {
          const data = res.data
          this.dataKra = data.data?.map(item => new KraModel(item))
          this.total = data.total
          this.lastPage = data.last_page
          this.page = data.current_page
        }
      }).catch(e => {
        console.log(e)
      }).finally(() => this.loading = false)
    },

    getListDepartment() {
      this.$store.dispatch(GET_DEPARTMENT).then(res => {
        if (!res.error) {
          this.departments = res.data ?? []
        }
      })
    },
    filterKra() {
      this.page = 1
      this.getListKra()
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Duyệt thay đổi KRA", name: 'ManageKraList'},
      {title: "Quản lý nhân sự"}
    ]);
    this.getListDepartment()
    this.getListKra()
  }
}
</script>

<style scoped>

</style>